/* eslint-disable */

import { Point } from 'pixi.js';

export const isTouchDevice = () => window.matchMedia('(pointer: coarse) and (hover: none)').matches;

export const isMobile = () => window.innerWidth < 1024;

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isEdge = () => window.navigator.userAgent.indexOf("Edge") > -1;

export const degrees = radians => (radians * 180) / Math.PI;

export const radians = degrees => (degrees * Math.PI) / 180;

export const angleBetween = (v1, v2) => Math.atan2(v2.y - v1.y, v2.x - v1.x);

export const norm = (val, max, min) => (val - min) / (max - min);

export const distanceBetween = (v1, v2) => Math.sqrt((v1.x - v2.x) * (v1.x - v2.x) + (v1.y - v2.y) * (v1.y - v2.y));

export const viewport = () => {
  const viewport = {
    width: window.innerWidth,
    height: window.innerHeight,
    ratio: window.innerWidth / window.innerHeight,
  };

  return viewport;
};

export const lerp = (a, b, n) => ((1 - n) * a) + (n * b);

export const setCover = (sprite, viewport) => {
  if (!sprite || !viewport) return;
  const rw = viewport.width >= sprite.width ? (viewport.width / sprite.width) : (sprite.width / viewport.width);
  const rh = viewport.height >= sprite.height ? (viewport.height / sprite.height) : (sprite.height / viewport.height);
  const r = Math.max(rw, rh);
  sprite.anchor = new Point(0.5, 0.5);
  sprite.position = new Point(viewport.width / 2, viewport.height / 2);
  sprite.scale = new Point(r, r);
};

export const getRatio = (clamp = true) => {
  return clamp ? {
    x: Math.max(window.innerWidth / 1920, 0.6),
    y: Math.max(window.innerHeight / 1080, 0.6),
  } : {
    x: Math.max(window.innerWidth / 1920, 0.3),
    y: Math.max(window.innerHeight / 1080, 0.3),
  }
}